<template>
  <div class="collapses collapse-item" :class="{ 'is-active': active }">
    <div class="collapse-header touchable" role="tab" :aria-expanded="active ? 'true' : 'false'" @click.prevent="toggle">
      <slot name="collapsible-header"></slot>
    </div>
    <transition
      name="fade"
      :duration="{ enter: 300, leave: 0 }"
    >
      <div class="collapse-content" v-show="active">
        <div class="collapse-content-box">
          <slot name="collapsible-body"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "Collapse",
    data(){
      return {
        active: this.selected
      }
    },
    props: {
      selected: {
        type: Boolean,
        required: true
      }
    },
    watch: {
      selected: function (newValue, oldValue) {
        if (newValue && !oldValue) {
          this.active = true;
          this.$emit('toggle', this.active)
        }
      }
    },
    methods: {
      toggle () {
        this.active = !this.active;
        this.$emit('toggle', this.active)
      },
    }
  }
</script>
<style scoped>
  .collapse-content {
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// Collapse.vue?ab69f48c